export const PAGE_SIZES = [10, 20, 30];

export const PAGINATION_TOTAL_VISIBLE = 11;

export const DASHBOARD_MESSAGE_TYPES = [
  'SMS',
  'LMS',
  'MMS',
  'FRIENDTALK_TEXT',
  'FRIENDTALK_IMAGE',
  'FRIENDTALK_WIDE_IMAGE',
  'FRIENDTALK_WIDE_ITEM_LIST',
  'FRIENDTALK_COMMERCE',
  'FRIENDTALK_CAROUSEL_FEED',
  'FRIENDTALK_CAROUSEL_COMMERCE',
  'FRIENDTALK_PREMIUM_VIDEO',
  'ALIMTALK_BA',
  'ALIMTALK_EX',
  'ALIMTALK_AD',
  'ALIMTALK_MI',
  'BRANDTALK_TEXT',
  'BRANDTALK_IMAGE',
  'BRANDTALK_WIDE_IMAGE',
  'BRANDTALK_WIDE_ITEM_LIST',
  'BRANDTALK_COMMERCE',
  'BRANDTALK_CAROUSEL_FEED',
  'BRANDTALK_CAROUSEL_COMMERCE',
  'BRANDTALK_PREMIUM_VIDEO',
];

export const MESSAGE_TYPE_OPTIONS = [
  {
    value: 'ALIMTALK_BA',
    text: 'alimTalkTemplate.messageBasic',
  },
  {
    value: 'ALIMTALK_EX',
    text: 'alimTalkTemplate.messageAdditionalInformation',
  },
  {
    value: 'ALIMTALK_AD',
    text: 'alimTalkTemplate.messageChannelAddition',
  },
  {
    value: 'ALIMTALK_MI',
    text: 'alimTalkTemplate.messageCompound',
  },
];

export const MESSAGE_TYPES = MESSAGE_TYPE_OPTIONS.map(({ value }) => value);

export const EMPHASIS_TYPE_OPTIONS = [
  {
    value: 'NONE',
    text: 'alimTalkTemplate.notSelected',
  },
  {
    value: 'TEXT',
    text: 'alimTalkTemplate.text',
  },
  {
    value: 'IMAGE',
    text: 'alimTalkTemplate.image',
  },
  {
    value: 'ITEM_LIST',
    text: 'alimTalkTemplate.itemList',
  },
];

export const EMPHASIS_TYPES = EMPHASIS_TYPE_OPTIONS.map(({ value }) => value);

export const BUTTON_TYPE_OPTIONS = [
  {
    value: 'DS',
    text: 'alimTalkTemplate.delivery',
  },
  {
    value: 'WL',
    text: 'alimTalkTemplate.webLink',
  },
  {
    value: 'AL',
    text: 'alimTalkTemplate.appLink',
  },
  {
    value: 'MD',
    text: 'alimTalkTemplate.messageDelivery',
  },
  {
    value: 'BF',
    text: 'alimTalkTemplate.businessFormType',
    // OP-166: 카카오 비즈니스폼(BF) 버튼 지원 종료 — 선택 불가 (기존 템플릿 표시용으로만 유지)
    disabled: true,
  },
  {
    value: 'AC',
    text: 'alimTalkTemplate.addChannelBtn',
    disabled: true,
  },
];

export const BUTTON_TYPES = BUTTON_TYPE_OPTIONS.map(({ value }) => value);

export const TEXTMESSAGE_IMAGE_TYPES = [
  {
    value: 'MMS_IMAGE',
    label: 'image.MMS_IMAGE',
  },
];

export const FRIENDTALK_IMAGE_TYPES = [
  {
    value: 'NORMAL_IMAGE',
    label: 'image.NORMAL_IMAGE',
  },
  {
    value: 'WIDE_IMAGE',
    label: 'image.WIDE_IMAGE',
  },
  {
    value: 'MAIN_WIDE_ITEM_LIST_IMAGE',
    label: 'image.MAIN_WIDE_ITEM_LIST_IMAGE',
  },
  {
    value: 'WIDE_ITEM_LIST_IMAGE',
    label: 'image.WIDE_ITEM_LIST_IMAGE',
  },
  {
    value: 'CAROUSEL_FEED_IMAGE',
    label: 'image.CAROUSEL_FEED_IMAGE',
  },
  {
    value: 'CAROUSEL_COMMERCE_IMAGE',
    label: 'image.CAROUSEL_COMMERCE_IMAGE',
  },
];

export const BRANDTALK_IMAGE_TYPES = [
  {
    value: 'NORMAL_IMAGE',
    label: 'image.brand.NORMAL_IMAGE',
  },
  {
    value: 'WIDE_IMAGE',
    label: 'image.brand.WIDE_IMAGE',
  },
  {
    value: 'MAIN_WIDE_ITEM_LIST_IMAGE',
    label: 'image.brand.MAIN_WIDE_ITEM_LIST_IMAGE',
  },
  {
    value: 'WIDE_ITEM_LIST_IMAGE',
    label: 'image.brand.WIDE_ITEM_LIST_IMAGE',
  },
  {
    value: 'CAROUSEL_FEED_IMAGE',
    label: 'image.brand.CAROUSEL_FEED_IMAGE',
  },
  {
    value: 'CAROUSEL_COMMERCE_IMAGE',
    label: 'image.brand.CAROUSEL_COMMERCE_IMAGE',
  },
];

export const ALIMTALK_IMAGE_TYPES = [
  {
    value: 'ALIMTALK_IMAGE',
    label: 'image.ALIMTALK_IMAGE',
  },
  {
    value: 'ALIMTALK_ITEM_HIGHLIGHT_IMAGE',
    label: 'image.ALIMTALK_ITEM_HIGHLIGHT_IMAGE',
  },
];

export const IMAGE_TYPES = {
  textmessage: TEXTMESSAGE_IMAGE_TYPES,
  friendtalk: FRIENDTALK_IMAGE_TYPES,
  brandtalk: BRANDTALK_IMAGE_TYPES,
  alimtalk: ALIMTALK_IMAGE_TYPES,
};

export const ALIMTALK_CATEGORIES = [
  {
    label: 'category.001.label',
    value: '001',
    children: [
      {
        value: '001001',
        label: 'category.001001.label',
        inclusion: ['category.001001.inclusion.0'],
        exclusion: ['category.001001.exclusion.0'],
      },
      {
        value: '001002',
        label: 'category.001002.label',
        inclusion: ['category.001002.inclusion.0'],
        exclusion: [],
      },
      {
        value: '001003',
        label: 'category.001003.label',
        inclusion: ['category.001003.inclusion.0'],
        exclusion: [],
      },
    ],
  },
  {
    label: 'category.002.label',
    value: '002',
    children: [
      {
        value: '002001',
        label: 'category.002001.label',
        inclusion: ['category.002001.inclusion.0'],
        exclusion: ['category.002001.exclusion.0'],
      },
      {
        value: '002002',
        label: 'category.002002.label',
        inclusion: ['category.002002.inclusion.0'],
        exclusion: ['category.002002.exclusion.0'],
      },
      // {
      //   value: '002003',
      //   label: 'category.002003.label',
      //   inclusion: ['category.002003.inclusion.0'],
      //   exclusion: ['category.002003.exclusion.0'],
      // },
      {
        value: '002004',
        label: 'category.002004.label',
        inclusion: ['category.002004.inclusion.0'],
        exclusion: [],
      },
      {
        value: '002005',
        label: 'category.002005.label',
        inclusion: ['category.002005.inclusion.0'],
        exclusion: [],
      },
    ],
  },
  {
    label: 'category.003.label',
    value: '003',
    children: [
      {
        value: '003001',
        label: 'category.003001.label',
        inclusion: ['category.003001.inclusion.0'],
        exclusion: [
          'category.003001.exclusion.0',
          'category.003001.exclusion.1',
        ],
      },
      // {
      //   value: '003002',
      //   label: 'category.003002.label',
      //   inclusion: [
      //     'category.003002.inclusion.0',
      //     'category.003002.inclusion.1',
      //     'category.003002.inclusion.2',
      //   ],
      //   exclusion: [],
      // },
      {
        value: '003003',
        label: 'category.003003.label',
        inclusion: ['category.003003.inclusion.0'],
        exclusion: [],
      },
      // {
      //   value: '003004',
      //   label: 'category.003004.label',
      //   inclusion: ['category.003003.inclusion.0'],
      //   exclusion: [],
      // },
    ],
  },
  {
    label: 'category.009.label',
    value: '009',
    children: [
      {
        value: '009001',
        label: 'category.009001.label',
        inclusion: ['category.009001.inclusion.0'],
        exclusion: [
          'category.009001.exclusion.0',
          'category.009001.exclusion.1',
        ],
      },
      {
        value: '009002',
        label: 'category.009002.label',
        inclusion: ['category.009002.inclusion.0'],
        exclusion: [
          'category.009002.exclusion.0',
          'category.009002.exclusion.1',
        ],
      },
      {
        value: '009003',
        label: 'category.009003.label',
        inclusion: ['category.009003.inclusion.0'],
        exclusion: ['category.009003.exclusion.0'],
      },
      {
        value: '009004',
        label: 'category.009004.label',
        inclusion: ['category.009004.inclusion.0'],
        exclusion: ['category.009004.exclusion.0'],
      },
      {
        value: '009005',
        label: 'category.009005.label',
        inclusion: ['category.009005.inclusion.0'],
        exclusion: [],
      },
    ],
  },
  {
    label: 'category.005.label',
    value: '005',
    children: [
      {
        value: '005001',
        label: 'category.005001.label',
        inclusion: ['category.005001.inclusion.0'],
        exclusion: [],
      },
      {
        value: '005002',
        label: 'category.005002.label',
        inclusion: ['category.005002.inclusion.0'],
        exclusion: ['category.005002.exclusion.0'],
      },
      {
        value: '005003',
        label: 'category.005003.label',
        inclusion: ['category.005003.inclusion.0'],
        exclusion: [],
      },
      {
        value: '005004',
        label: 'category.005004.label',
        inclusion: ['category.005004.inclusion.0'],
        exclusion: [],
      },
      {
        value: '005005',
        label: 'category.005005.label',
        inclusion: ['category.005005.inclusion.0'],
        exclusion: [],
      },
      {
        value: '005006',
        label: 'category.005006.label',
        inclusion: ['category.005006.inclusion.0'],
        exclusion: [],
      },
    ],
  },
  {
    label: 'category.006.label',
    value: '006',
    children: [
      {
        value: '006001',
        label: 'category.006001.label',
        inclusion: ['category.006001.inclusion.0'],
        exclusion: ['category.006001.exclusion.0'],
      },
      // {
      //   value: '006002',
      //   label: 'category.006002.label',
      //   inclusion: [
      //     'category.006002.inclusion.0',
      //     'category.006002.inclusion.1',
      //     'category.006002.inclusion.2',
      //   ],
      //   exclusion: [],
      // },
      {
        value: '006003',
        label: 'category.006003.label',
        inclusion: ['category.006003.inclusion.0'],
        exclusion: [],
      },
      // {
      //   value: '006004',
      //   label: 'category.006004.label',
      //   inclusion: [
      //     'category.006004.inclusion.0',
      //     'category.006004.inclusion.1',
      //     'category.006004.inclusion.2',
      //   ],
      //   exclusion: [],
      // },
    ],
  },
  {
    label: 'category.999.label',
    value: '999',
    children: [
      {
        value: '999999',
        label: 'category.999999.label',
        inclusion: [],
        exclusion: [],
      },
    ],
  },
  {
    label: 'category.004.label',
    value: '004',
    children: [
      {
        value: '004001',
        label: 'category.004001.label',
        inclusion: ['category.004001.inclusion.0'],
        exclusion: [],
      },
      {
        value: '004002',
        label: 'category.004002.label',
        inclusion: ['category.004002.inclusion.0'],
        exclusion: [],
      },
      {
        value: '004003',
        label: 'category.004003.label',
        inclusion: ['category.004003.inclusion.0'],
        exclusion: [],
      },
      {
        value: '004004',
        label: 'category.004004.label',
        inclusion: ['category.004004.inclusion.0'],
        exclusion: ['category.004004.exclusion.0'],
      },
      {
        value: '004005',
        label: 'category.004005.label',
        inclusion: ['category.004005.inclusion.0'],
        exclusion: ['category.004005.exclusion.0'],
      },
      {
        value: '004006',
        label: 'category.004006.label',
        inclusion: ['category.004006.inclusion.0'],
        exclusion: [],
      },
      {
        value: '004007',
        label: 'category.004007.label',
        inclusion: ['category.004007.inclusion.0'],
        exclusion: [],
      },
      {
        value: '004008',
        label: 'category.004008.label',
        inclusion: ['category.004008.inclusion.0'],
        exclusion: [],
      },
    ],
  },
  {
    label: 'category.007.label',
    value: '007',
    children: [
      {
        value: '007001',
        label: 'category.007001.label',
        inclusion: ['category.007001.inclusion.0'],
        exclusion: [],
      },
      {
        value: '007002',
        label: 'category.007002.label',
        inclusion: ['category.007002.inclusion.0'],
        exclusion: [],
      },
      {
        value: '007003',
        label: 'category.007003.label',
        inclusion: ['category.007003.inclusion.0'],
        exclusion: [],
      },
      {
        value: '007004',
        label: 'category.007004.label',
        inclusion: ['category.007004.inclusion.0'],
        exclusion: [],
      },
    ],
  },
  {
    label: 'category.008.label',
    value: '008',
    children: [
      {
        value: '008001',
        label: 'category.008001.label',
        inclusion: ['category.008001.inclusion.0'],
        exclusion: [],
      },
      {
        value: '008002',
        label: 'category.008002.label',
        inclusion: ['category.008002.inclusion.0'],
        exclusion: [],
      },
    ],
  },
];

export const COUPON_TYPE_OPTIONS = [
  {
    text: 'common.couponType.numberDiscount',
    type: 'NUMBER_DISCOUNT',
  },
  {
    text: 'common.couponType.percentDiscount',
    type: 'PERCENT_DISCOUNT',
  },
  {
    text: 'common.couponType.deliveryDiscount',
    type: 'DELIVERY_DISCOUNT',
  },
  {
    text: 'common.couponType.freeCoupon',
    type: 'FREE_COUPON',
  },
  {
    text: 'common.couponType.upCoupon',
    type: 'UP_COUPON',
  },
];

export const KST_OFFSET_MINUTES = 9 * 60 * -1;

export const CORE_MESSAGE_GROUP_TYPES = [
  'Object',
  'Flow',
  'External',
  'Campaign',
  'Apex',
];

export const MC_MESSAGE_GROUP_TYPES = [
  'MC',
];
